import React from 'react';
import { Header } from '../Header';
import styles from './MainLayout.styles.scss';
import { Loader } from '../shared/Loading';
import { Footer } from '../Footer';
import cn from 'classnames';
import { useAuthentication } from '../../hooks/useAuthentication';

const MainLayout = ({
  children,
  loading,
  eInvoicing,
  className,
  bannerClassName,
}) => {
  const { isAuthenticated, userInfo } = useAuthentication();

  return (
    <div className={cn(styles.layout)}>
      <Loader active={!isAuthenticated || !userInfo?.firstName}>
        <Header />
        <div className={cn(styles.inner, className)}>
          <Loader active={loading}>
            {eInvoicing ? (
              <div className={cn(styles.withBanner, bannerClassName)}>
                {children}
              </div>
            ) : (
              children
            )}
          </Loader>
        </div>
        <Footer />
      </Loader>
    </div>
  );
};

export default React.memo(MainLayout);
